import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import EmployeeDashboard from './pages/EmployeeDashboard';
import ApplyLeave from './pages/ApplyLeave';
import LeaveHistory from './pages/LeaveHistory';
import AdminDashboard from './pages/AdminDashboard';
import EmployeeManagement from './pages/EmployeeManagement';
import UserManagement from './pages/UserManagement';
import CompanyHolidays from './pages/CompanyHolidays';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import LateTracking from './pages/LateTracking';
import { Toaster } from 'sonner';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  // Helper to check if user is an employee or manager (non-admin)
  const isEmployeeOrManager = user && (user.role === 'Employee' || user.role === 'Manager');

  return (
    <>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={!user ? <Login onLogin={handleLogin} /> : <Navigate to={user.role === 'Admin' ? '/admin' : '/dashboard'} />}
          />
          <Route
            path="/reset-password"
            element={<ResetPassword />}
          />
          <Route
            path="/dashboard"
            element={isEmployeeOrManager ? <EmployeeDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/apply-leave"
            element={isEmployeeOrManager ? <ApplyLeave user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/leave-history"
            element={isEmployeeOrManager ? <LeaveHistory user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin"
            element={user && user.role === 'Admin' ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin/employees"
            element={user && user.role === 'Admin' ? <EmployeeManagement user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin/users"
            element={user && user.role === 'Admin' ? <UserManagement user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin/holidays"
            element={user && user.role === 'Admin' ? <CompanyHolidays user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin/reports"
            element={user && user.role === 'Admin' ? <Reports user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin/settings"
            element={user && user.role === 'Admin' ? <Settings user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin/late-tracking"
            element={user && user.role === 'Admin' ? <LateTracking user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
          />
          <Route path="/" element={<Navigate to={user ? (user.role === 'Admin' ? '/admin' : '/dashboard') : '/login'} />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;